module.exports = __webpack_public_path__ + "9779d9a1/img/verified-icon.f93bbc14.svg";